import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import BrandLogo from './sdg_logo.png'
import Navbar from 'react-bootstrap/Navbar';

import Collapsible from 'react-collapsible';

// model images
import IOTSU_S1R_L01 from './model_images/IOTSU_S1R_L01.jpg'
import IOTSU_S1_MG01 from './model_images/IOTSU_S1_MG01.jpg'
//import IOTSU_M1 from './model_images/IOTSU_M1.jpg'

import IOTSU_S1_AQX1 from './model_images/IOTSU_S1_AQX1.jpg'
import IOTSU_S1_TH02 from './model_images/IOTSU_S1.jpg'
import IOTSU_S1_A01 from './model_images/IOTSU_S1_A01.jpg'
import IOTSU_S1_M04 from './model_images/IOTSU_S1_M04.jpg'
import IOTSU_S1R_M04 from './model_images/IOTSU_S1R_M04.jpg'
import IOTSU_S1_G01 from './model_images/IOTSU_S1_G01.jpg'
import IOTSU_S2R_L02 from './model_images/IOTSU_S2R_L02.jpg'
import IOTSU_L2_IAQ from './model_images/l2_iaq.png'
import IOTSU_L2R_L02 from './model_images/IOTSU_S2R_L02.jpg'
import IOTSU_L2_EPD01 from './model_images/IOTSU_L2_EPD01.jpg'
import IOTSU_L4_AQ08 from './model_images/IOTSU_L4_AQ08.jpg'
import IOTSU_L5R_L04 from './model_images/IOTSU_L5R_L04.jpg'
import DOCUMENT_ICON from "./document.svg"

// Types of device brand logos

import SIGFOX_LOGO from "./sigfox_logo.png"
import LORAWAN_LOGO from "./lorawan_logo.png"

// Types of storefronts
import THINGPARK_MARKET from "./store_images/thingpark_market.png"
import CONTACT_US from "./store_images/email.png"

// array of devices, could be json
const devices = [
  {
    id: 1,
    name: 'IOTSU S1R L01 Atlas Location Tracker',
    description: "IOTSU® Atlas is a wireless device that measures temperature and location using the Sigfox Atlas geolocation service. IOTSU® Atlas is designed for cold chain management and tracking of transports. The accuracy is typically 1-10 km depending on the coverage of the Sigfox network.  \n\nIOTSU® Atlas can be mounted on any object such as a deliverable package, container or vehicle. The device is maintenance-free and encased in an industrial quality casing resistant to dust and splatter. Installation is fast and easy. Transmission and measurement cycles can be adjusted according to the need. This affects the battery life.",
    sigfox: true,
    atlas: true,
    temperature: true,
    accelleration: true,
    image: IOTSU_S1R_L01,
    moreInformation: { __html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>35 x 35 x 90 mm <br/> <b>Weight: </b> 92 g with battery <br/> <b>Sensors: </b> Temperature, Acceleration <br/> <b>Transmission cycle: </b>Configurable, alerts <br/> <b>Connectivity: </b> Sigfox RC1<br/> <b>IP Class: </b> 67<br/> <b>Battery: </b> Size AA 3.6V, lifetime with default settings 5 years, replaceable <br/> <b>Operating Conditions: </b> -30°C to +50°C<br/> <b>Mounting: </b>Adhesive tape, Screws <br/> ' },
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1R_L01.pdf",
    }
    ],
  },
  {
    id: 2,
    name: 'IOTSU S1 MG01 Visitor Counter',
    description: "IOTSU® Visitor Counter is a wireless device for long-time, maintenance-free monitoring of presence and passage. IOTSU® indicates the presence, number of visitors and the direction of the movement. IOTSU® is mounted to the door frame.\n\n Battery life is affected by the level of activity in the motion sensor’s field of view and by the transmit interval of the Sigfox interface. The default transmit interval is adjustable. ",
    sigfox: true,
    motion: true,
    image: IOTSU_S1_MG01,
    moreInformation: { __html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b> 77 x 25 x 22mm without sensor or sealants<br/> <b>Weight: </b>40 g with battery <br/> <b>Sensors: </b>PIR + Hall effect sensor<br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Heartbeat: </b>Once per 24h <br/><b>Connectivity: </b>Sigfox RC1<br/> <b>Antenna class: </b>Sigfox Class 0U<br/> <b>Battery: </b>AA 3.6V, replaceable<br/> <b>Operating Temperature: </b>-5°C to +50°C<br/> <b>Sensing Distance: </b>5m<br/> <b>Field of View: </b>90° x 90°<br/> <b>Mounting: </b>Adhersive tape<br/> <b>Certifications: </b>CE<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_MG01.pdf",
    }
    ],
  },
  {
    id: 4,
    name: 'IOTSU S1R T02 Temperature',
    description: "IOTSU® M1 is an excellent solution for long-term wireless asset tracking. IOTSU® M1 can be attached onto any vehicle, tool or container. It collects location data and sends it to the cloud. The device is easily integrated into Small Data Garden IoT platform to visualise, analyse and report the measurements. The measurements are stored in the system. Easy report generation from desired time period makes this service a very efficient tool for all kind of monitoring, reporting and development.\n\nIOTSU® M1 is also easy to integrate into other systems and processes. IOTSU® supports confgurable SMS and email alarms. The device is maintenance-free and easy to install. There is no need for external power supply or internet connection.",
    sigfox: true,
    temperature: true,
    image: IOTSU_S1R_L01,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>35 x 35 x 90mm <br/> <b>Weight: </b>92 g with battery<br/> <b>Sensors: </b>Temperature<br/> <b>Transmission cycle: </b>4h, adjustable <br/> <b>Measurement Cycle: </b>30min, adjustable<br/> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Antenna Class: </b>Sigfox Class 0u<br/> <b>IP Class: </b> 67<br> <b>Battery: </b>Size AA 3.6V, lifetime with default settings 5 years, replaceable<br/> <b>Operating Conditions: </b>-30°C to +50°C <br/> <b>Accuracy: </b>Typical ± 0.25°C<br/> <b>Mounting: </b>Adhesive tape<br/> <b>Certifications</b>CE<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1R_T02.pdf",
    }
    ],       
  },
  {
    id: 5,
    name: 'IOTSU S1 AQX1 Temperature, Humidity, CO2 & tVOC',
    description: "IOTSU® AQX1 sensor is a wireless indoor device that measures air quality. Air quality is assessed as a combination of temperature, humidity, the concentration of carbon dioxide and the concentration of volatile organic compound (VOC). Volatile organic compounds are evaporated particles in air from an array of sources some of which may have an effect on an individuals health or comfort.\n\nThe device can be mounted on any surface within the monitored building. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.",
    sigfox: true,
    temperature: true,
    humidity: true,
    co2: true,
    voc: true,
    image: IOTSU_S1_AQX1,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>76 x 76 x 30 mm<br/> <b>Weight: </b>92 g with battery<br/> <b>Sensors: </b>CO₂ (0 – 5000 ppm), VOC, Temperature, Humidity<br/> <b>Transmission cycle: </b>2h, adjustable, Configurable, alerts<br/> <b>Measurement Cycle: </b>30min, adjustable<br/> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Battery: </b>Size AA 3.6V, lifetime with default settings 3 years, replaceable<br/> <b>Operating Temperature: </b>0°C to +50°C <br/> <b>Mounting: </b>Adhesive tape<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_AQX1.pdf",
    }
    ],        
  },
  {
    id: 6,
    name: 'IOTSU S1 AQX3 Temperature, Humidity & tVOC',
    description: "IOTSU® AQX3 sensor is a wireless indoor device that measures air quality. The device is assessed as a combination of temperature, humidity and the concentration of volatile organic compound (VOC). Volatile organic compounds are evaporated particles in air from an array of sources some of which may have an effect on an individuals health or comfortability.\n\nThe device can be mounted on any surface within the monitored building. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.",
    sigfox: true,
    temperature: true,
    humidity: true,
    voc: true,
    image: IOTSU_S1_AQX1,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>76 x 76 x 30 mm<br/> <b>Weight: </b>92 g with battery<br/> <b>Sensors: </b>VOC, Temperature, Humidity<br/> <b>Transmission cycle: </b>2h, adjustable, Configurable, alerts<br/> <b>Measurement Cycle: </b>30min, adjustable<br/> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Battery: </b>Size AA 3.6V, lifetime with default settings 3 years, replaceable<br/> <b>Operating Temperature: </b>0°C to +50°C <br/> <b>Mounting: </b>Adhesive tape<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_AQX3.pdf",
    }
    ],      
  },
  {
    id: 7,
    name: 'IOTSU S1 AQ05 Temperature, Humidity & CO2',
    description: "IOTSU® AQ05 sensor is a wireless indoor device that measures the concentration of carbon dioxide. IOTSU® CO₂ is designed for measuring and recording of changes in air quality for statistical analysis or monitoring purposes.\n\nThe device can be mounted on any surface within the monitored building. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need. ",
    sigfox: true,
    temperature: true,
    humidity: true,
    co2: true,
    image: IOTSU_S1_AQX1,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>76 x 76 x 30 mm <br/> <b>Weight: </b>92g with battery<br/> <b>Sensors: </b>CO₂ (0 – 5000 ppm), Temperature, Humidity<br/> <b>Transmission cycle: </b>2h, adjustable, Configurable, alerts<br/> <b>Measurement Cycle: </b>30min, adjustable<br/> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Battery: </b>3.6V, lifetime with default settings 3 years, replaceable<br/> <b>Operating Temperature: </b>0°C to +50°C<br/> <b>Mounting: </b>Adhesive tape<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_AQ05.pdf",
    }
    ],        
  },
  {
    id: 8,
    name: 'IOTSU S1 TH02 Temperature & Humidity',
    description: "IOTSU® TH02 is a wireless indoor device that measures air temperature and relative humidity. IOTSU® TH02 can be used for long-time monitoring of real estates and building structures.\n\nThe device can be mounted on any surface within the monitored building. Installation of this maintenance-free device is quick and easy. Cycles of measurement and transmission can be adjusted according to the need, which influences the battery life. The product is also available as a version for outdoor usage and extended temperature range.",
    sigfox: true,
    temperature: true,
    humidity: true,
    image: IOTSU_S1_TH02,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>77 x 25 x 22mm<br/> <b>Weight: </b>40 g with battery<br/> <b>Sensors: </b>Temperature, humidity<br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Measurement Cycle: </b>30min, adjustable<br/> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Antenna Class: </b>Sigfox Class 0u<br/> <b>IP Class: </b>5X (indoor)<br> <b>Battery: </b>3.6V, lifetime with default settings 3 years, replaceable<br/> <b>Operating Conditions: </b>-5°C to +50°C, Relative humidity ≤80% (Non-condensing)<br/> <b>Mounting: </b>Adhesive tape<br/> <b>Certifications</b>CE<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_TH02.pdf",
    }
    ],      
  },
  {
    id: 9,
    name: 'IOTSU S1 A01 Accelleration',
    description: "IOTSU® Acceleration is a wireless indoor device that measures acceleration and gathers statistical usage data. IOTSU® is designed for monitoring movement, falling or position changes of an object.\n\nInstallation of this maintenance-free device is very quick and easy. Transmission and measurement cycles can be adjusted according to the need. IOTSU® can be mounted on any object such as deliverable packages, containers or vehicles. An optional casing for outdoor use is available.",
    sigfox: true,
    accelleration: true,
    image: IOTSU_S1_A01,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>77 x 25 x 22mm<br/> <b>Weight: </b>40 g with battery<br/> <b>Sensors: </b>Acceleration<br/> <b>Transmission cycle: </b>Configurable, alerts<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Battery: </b>3.6V, lifetime with default settings 3 years, replaceable<br/> <b>Operating Conditions: </b>-5°C to +50°C<br/> <b>Mounting: </b>Adhesive tape, magnet<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_A01.pdf",
    }
    ],      
  },
  {
    id: 10,
    name: 'IOTSU S1 M04 Motion',
    description: "IOTSU® Motion is a wireless motion detector that can sense human presence indoors. The device has an integrated counting algorithm which it utilizes to provide visitor count statistics. It can also act as an alarm device. The operating mode and sensitivity level can be configured over the air.\n\nInstallation of this maintenance-free device is quick and easy. Battery life is influenced by the level of activity in the motion sensor’s field of view and by the transmit interval of the Sigfox interface. The default transmit interval is adjustable. The product is also available as a version for outdoor usage. ",
    sigfox: true,
    motion: true,
    image: IOTSU_S1_M04,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>77 x 25 x 22m without sensor or sealants<br/> <b>Weight: </b>40 g with battery<br/> <b>Sensors: </b>PIR<br/> <b>Transmission cycle: </b>Once per 30min<br/> <b>Heartbeat: </b>Once per 24h</br> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Antenna Class: </b>Sigfox Class 0u<br/> <b>IP Class: </b>5X (indoor)<br> <b>Battery: </b>3.6V, replaceable<br/> <b>Operating Temperature: </b>-5°C to +50°C<br/> <b>Sensing Distance: </b>5m<br/> <b>Field of View: </b>90°x 90°<br/> <b>Mounting: </b>Adhesive tape, magnet<br/> <b>Certifications: </b>CE<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_M04.pdf",
    }
    ],      
  },
  {
    id: 11,
    name: 'IOTSU S1R M04 Motion',
    description: "IOTSU® Motion is a wireless motion detector that can sense human presence indoors. The device has an integrated counting algorithm which it utilizes to provide visitor count statistics. It can also act as an alarm device. The operating mode and sensitivity level can be configured over the air.\n\nInstallation of this maintenance-free device is quick and easy. Battery life is influenced by the level of activity in the motion sensor’s field of view and by the transmit interval of the Sigfox interface. The default transmit interval is adjustable. The product is also available as a version for outdoor usage. ",
    sigfox: true,
    motion: true,
    image: IOTSU_S1R_M04,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>35 x 35 x 90 mm without sensor lens<br/> <b>Weight: </b>92 g with battery<br/> <b>Sensors: </b>PIR<br/> <b>Transmission cycle: </b>Once per 30min<br/> <b>Heartbeat: </b>Once per 24h</br> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Antenna Class: </b>Sigfox Class 0u<br/> <b>IP Class: </b>67<br> <b>Battery: </b>AA 3.6V, replaceable<br/> <b>Operating Temperature: </b>-30°C to +50°C<br/> <b>Sensing Distance: </b>2.2m to 3.1m<br/> <b>Field of View: </b>91°x 91°<br/> <b>Mounting: </b>Adhesive tape, magnet, screws<br/> <b>Certifications: </b>CE<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1R_M04.pdf",
    }
    ],      
  },
  {
    id: 12,
    name: 'IOTSU L2 TH02 Temperature & Humidity',
    description: "IOTSU® TH02 sensor is a wireless indoor device that measures air quality. Air quality is assessed as a combination of temperature & humidity. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.",
    lorawan: true,
    temperature: true,
    humidity: true,
    image: IOTSU_L2_IAQ,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>80 x 120 x 35 mm<br/> <b>Weight: </b>170g with battery<br/> <b>Sensors: </b>Temperature, Humidity <br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Measurement Cycle: </b>Transmission cycle / 4<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>Battery: </b>C, 3.6v, lifetime with default settings 5 years, replaceable<br/> <b>IP Class: </b>IP30<br/> <b>Operating Conditions: </b>0°C to +50°C, Relative humidity 85% (Non-condensing)<br/> <b>Typical Accuracy: </b>Temperature: ±0.2°C Humidity: ±2%<br/> <b>Certifications: </b>CE<br/> <b>Mounting: </b>Adhesive tape, screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2_TH02.pdf",
    }
    ],
    purchase: [{
      title: "Thingpark Market",
      url: "https://market.thingpark.com/iotsu-l2-aq01-temperature-humidity-co2-tvoc-4.html?___store=default",
      icon: THINGPARK_MARKET
    }
    ],             
  },
  {
    id: 13,
    name: 'IOTSU L2 DP01 Differential Pressure',
    description: "IOTSU® DP01 sensor is a wireless indoor device that measures air quality. The sensor can be used to measure differential pressure. Transmission and measurement cycles can be adjusted according to the need.",
    pressure: true,
    lorawan: true,
    image: IOTSU_L2_IAQ,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>80 x 120 x 35 mm<br/> <b>Weight: </b>170g with battery<br/> <b>Sensors: </b>Differential Pressure<br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Measurement Cycle: </b>Transmission cycle / 4<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>Battery: </b>C, 3.6v, lifetime with default settings 5 years, replaceable<br/> <b>IP Class: </b>IP30<br/> <b>Operating Conditions: </b>0°C to +50°C<br/> <b>Typical Accuracy: </b>3% of reading, < 0.01 Pa<br/> <b>Certifications: </b>CE<br/> <b>Mounting: </b>Adhesive tape, screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2_DP01.pdf",
    }
    ], 
    purchase: [{
      title: "Thingpark Market",
      url: "https://market.thingpark.com/iotsu-l2-aq01-temperature-humidity-co2-tvoc-3.html?___store=default",
      icon: THINGPARK_MARKET
    }
    ],            
  },
  {
    id: 13,
    name: 'IOTSU L2 AQ05 Temperature, Humidity & CO2',
    description: "IOTSU® AQ05 sensor is a wireless indoor device that measures air quality. Air quality is assessed as a combination of temperature, humidity and the concentration of carbon dioxide. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.",
    lorawan: true,
    temperature: true,
    humidity: true,
    co2: true,
    image: IOTSU_L2_IAQ,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>80 x 120 x 35 mm<br/> <b>Weight: </b>170g with battery<br/> <b>Sensors: </b>CO₂, Temperature, Humidity<br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Measurement Cycle: </b>Transmission cycle / 4<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>Battery: </b>C, 3.6v, lifetime with default settings 5 years, replaceable<br/> <b>IP Class: </b>IP30<br/> <b>Operating Conditions: </b>0°C to +50°C, Relative humidity ≤85% (Non-condensing)<br/> <b>Typical Accuracy: </b>Temperature: ±0.2°C, Humidity: ±2%, CO2: ±(30ppm + 3% of reading) <br/> <b>Certifications: </b>CE<br/> <b>Mounting: </b>Adhesive tape, screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2_AQ05.pdf",
    }
    ],
    purchase: [{
      title: "Thingpark Market",
      url: "https://market.thingpark.com/iotsu-l2-aq01-temperature-humidity-co2-tvoc-2.html?___store=default",
      icon: THINGPARK_MARKET
    }
    ],             
  },
  {
    id: 14,
    name: 'IOTSU L2 AQ03 Temperature, Humidity & tVOC',
    description: "IOTSU® AQ03 sensor is a wireless indoor device that measures air quality. Air quality is assessed as a combination of temperature, humidity and the concentration of carbon dioxide. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.",
    lorawan: true,
    temperature: true,
    humidity: true,
    voc: true,
    image: IOTSU_L2_IAQ,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>80 x 120 x 35 mm<br/> <b>Weight: </b>170g with battery<br/> <b>Sensors: </b>VOC, Temperature, Humidity<br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Measurement Cycle: </b>Transmission cycle / 4<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>Battery: </b>C, 3.6v, lifetime with default settings 5 years, replaceable<br/> <b>IP Class: </b>IP30<br/> <b>Operating Conditions: </b>0°C to +50°C, Relative humidity 10-95% (Non-condensing) <br/> <b>Typical Accuracy: </b>Temperature: ±0.2°C, Humidity: ±2%, tVOC: ±15% <br/> <b>Certifications: </b>CE<br/> <b>Mounting: </b>Adhesive tape, screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2_AQ03.pdf",
    }
    ],
    purchase: [{
      title: "Thingpark Market",
      url: "https://market.thingpark.com/iotsu-l2-aq01-temperature-humidity-co2-tvoc-1.html?___store=default",
      icon: THINGPARK_MARKET
    }
    ],               
  },
  {
    id: 15,
    name: 'IOTSU L2 AQ01 Temperature, Humidity, CO2 & tVOC',
    description: "IOTSU® AQ01 sensor is a wireless indoor device that measures air quality. Air quality is assessed as a combination of temperature, humidity and the concentration of carbon dioxide. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.",
    lorawan: true,
    temperature: true,
    humidity: true,
    voc: true,
    co2: true,
    image: IOTSU_L2_IAQ,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>80 x 120 x 35 mm<br/> <b>Weight: </b>170g with battery<br/> <b>Sensors: </b>CO₂, VOC, Temperature, Humidity<br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Measurement Cycle: </b>Transmission cycle / 4<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>Battery: </b>C, 3.6v, lifetime with default settings 5 years, replaceable<br/> <b>IP Class: </b>IP30<br/> <b>Operating Conditions: </b>0°C to +50°C, Relative humidity 10-95% (Non-condensing) <br/> <b>Typical Accuracy: </b>Temperature: ±0.2°C, CO2: ±(30ppm + 3% of reading), Humidity: ±2%, tVOC: ±15% <br/> <b>Certifications: </b>CE<br/> <b>Mounting: </b>Adhesive tape, screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2_AQ01.pdf",
    }
    ],
    purchase: [{
      title: "Thingpark Market",
      url: "https://market.thingpark.com/iotsu-l2-aq01-temperature-humidity-co2-tvoc.html?___store=default",
      icon: THINGPARK_MARKET
    }
    ],        
  },
  {
    id: 16,
    name: 'IOTSU S1 G01 Door and Window',
    description: "IOTSU® Door and Window Sensor is a wireless indoor device which triggers from both opening and closing of doors, windows or any other similar applications.\n\nThe operation of the device is based on a magnetic sensor that detects whether the magnetic counterpiece is in the vicinity of the device or not. The product is also available as a version for outdoor usage.",
    sigfox: true,
    motion: true,
    image: IOTSU_S1_G01,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>77 x 25 x 22mm (x2)<br/> <b>Weight: </b>40g with battery<br/> <b>Sensors: </b>Hall effect sensor<br/> <b>Heartbeat: </b>Once per 24h</br> <b>Transmit Power: </b>25mW (14dBm)<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>Antenna Class: </b>Sigfox Class 0u<br/> <b>IP Class: </b>5X (indoor)<br> <b>Battery: </b>AA 3.6V, replaceable<br/> <b>Battery Lifetime: </b>5 to 20 years, depending on the amount of triggers<br/> <b>Operating Temperature: </b>-5°C to +50°C<br/> <b>Mounting: </b>Adhesive tape<br/> <b>Certifications: </b>CE<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S1_G01.pdf",
    }
    ],        
  },
  {
    id: 17,
    name: 'IOTSU S2R L03 GPS Location tracker',
    description: "IOTSU® S2R is an excellent solution for long-term wireless asset tracking. IOTSU® S2R can be attached onto any vehicle, tool or container. It collects location data and sends it to the cloud. The device is easily integrated into IOTSU® Cloud platform to visualise, analyse and report the measurements. The measurements are stored in the system. IOTSU® Cloud supports confgurable SMS and email alarms.  Easy report generation from desired time period makes this service a very efficient tool for asset tracking.\n\nIOTSU® S2R is also easy to integrate into other systems and processes. The device is maintenance-free and easy to install. There is no need for external power supply.\n- The tracker uses GPS satellite tracking to accurately locate assets.\n- The integrated accelerometer is used to conserve energy by only sending location information when the device is on the move.\n- The device is powered by an internal battery to allow tracking of non-powered assets for up to 10 years.",
    sigfox: true,
    temperature: true,
    gps: true,
    accelleration: true,
    image: IOTSU_S2R_L02,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>140 x 60 x 40 mm <br/> <b>Weight: </b>225g with battery <br/> <b>Sensors: </b>GPS, Acceleration, Temperature <br/> <b>Transmission cycle: </b>Configurable, alerts<br/> <b>Connectivity: </b>Sigfox RC1<br/> <b>IP Class: </b>67<br> <b>Battery: </b>2x size C 3.6v, replaceable<br/> <b>Operating Temperature: </b>-30°C to +50°C<br/> <b>Mounting: </b>Adhesive tape, screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_S2R_L03.pdf",
    }
    ], 
  },
  {
    id: 18,
    name: 'IOTSU L2R L03 GPS, Acceleration & Temperature',
    description: "IOTSU® L2R L03 sensor is a wireless location tracking device. The device is designed for tracking assets, monitoring critical transportations and cold chains, and optimizing machine and vehicle maintenance or any other application where ultra-long battery consumption is needed. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.\n\nThe device uses an integrated accelerometer to sense if it is in motion or not. When stationary the device will transmit periodic heartbeat messages with 24 hour intervals and once it is in motion it will start transmitting more frequently. This ensures that the battery is not wasted on tracking a stationary object.",
    lorawan: true,
    temperature: true,
    gps: true,
    accelleration: true,
    image: IOTSU_L2R_L02,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>140 x 60 x 40 mm <br/> <b>Weight: </b>225g with battery <br/> <b>Sensors: </b>GPS, Acceleration, Temperature <br/> <b>Transmission cycle: </b>Configurable, alerts<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>IP Class: </b>67<br> <b>Battery: </b>2x size C 3.6v, replaceable<br/> <b>Operating Temperature: </b>-30°C to +50°C<br/> <b>Mounting: </b>Adhesive tape, screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2R_L02.pdf",
    }
    ], 
    purchase: [{
      title: "Thingpark Market",
      url: "https://market.thingpark.com/iotsu-l2-aq01-temperature-humidity-co2-tvoc-5.html?___store=default",
      icon: THINGPARK_MARKET
    }
    ],        
  },
  {
    id: 20,
    name: 'IOTSU L2 EPD01 E-ink Display Unit',
    description: "IOTSU® E Ink can be used to display data from IoT applications including for example real estate management, logistics, industrial processes, and retail. Wirelessly connected content displays allow for convenient monitoring of information such as water and electricity consumption of apartments, air quality measurements or even cloud based data.\n\nIOTSU® E Ink can improve the usability of many battery-powered IoT devices such as real estate meters, cold-chain temperature data loggers and environmental sensors. The LoRaWAN communication interface enables smooth data transfers to and from the cloud.\n\n IOTSU® E Ink configuration tool allows the display content to be customized based on customer needs and allows presenting of user specific content such as sensor readings and QR-codes. IOTSU® E Ink provides at-a-glance visibility into data in real estate, logistics and manufacturing applications. The unit has a well defined API for interfacing with different cloud platforms. IOTSU® L2 uses the global LoRaWAN network connection. There is no need for external power supply.",
    lorawan: true,
    epd: true,
    image: IOTSU_L2_EPD01,
    moreInformation: {__html: '<h4>Technical specifications</h4> <br/> LPWAN device with configurable electrophoretic Display.<br/><br/> <b>Dimensions (LxWxH):</b> 80 x 120 x 35 mm<br/> <b>Weight:</b> 200g with battery<br/> <b>Display Size:</b> 57.2mm x 38.1mm (2.7\")<br/> <b>Display Features:</b> 264 x 176 pixel (117dpi), black/white<br/> <b>Update Query Rate:</b> configurable, default 20min<br/> <b>Battery:</b> 3.6V, lifetime with default settigns 5 years, replaceable<br/> <b>IP Class:</b> IP30<br/> <b>Operating Conditions: </b> 0°C to +50°C, humidity RH 40-85%, non-condensing<br/> <b>Mounting: </b> Screws, adhersive tape<br/> <br/> <i>* Default profile: Query rate 20 min, Update rate 1h, SF12</i> '},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2_EPD01.pdf",
    }
    ]        
  },
  {
    id: 21,
    name: 'IOTSU L2R T02 Temperature',
    description: "IOTSU® L2R T02 is a wireless device designed for long-time monitoring of temperature in outdoor environments. The device can be mounted on any surface within the monitored building. Installation of this maintenance-free device is quick and easy. Measurement and transmission cycles can be adjusted according to the need. The product is also available as a version for indoor usage and extended temperature range.\n\n IOTSU® L2 uses the global LoRaWAN network connection. There is no need for external power supply.",
    lorawan: true,
    temperature: true,
    image: IOTSU_L2R_L02,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>140 x 60 x 40 mm<br/> <b>Weight: </b>165g with battery<br/> <b>Sensors: </b>Temperature<br/> <b>Transmission cycle: </b>2h, adjustable<br/> <b>Measurement cycle: </b>Transmission cycle/4<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>IP Class: </b> 67<br> <b>Battery: </b>2x size C, replaceable. <br/> <b>Operating Conditions: </b>-30°C to +50°C<br/><b>Mounting: </b>Adhesive tape, screws<br/> '},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L2R_T02.pdf",
    }
    ]        
  },
  {
    id: 22,
    name: 'IOTSU L4 AQ08 Particulate Matter, Temperature, Humidity, CO₂,& tVOC',
    description: "IOTSU® L4 AQ08 sensor is a wireless indoor device designed for measuring and recording of changes in air quality. Air quality is assessed as a combination of particulate matter, temperature, humidity, and the concentration of carbon dioxide (CO2) and volatile organic compounds (tVOC).\n\n The device can be mounted on any surface within the monitored building. Installation of this maintenance-free device is quick and easy. Transmission and measurement cycles can be adjusted according to the need.\n\n IOTSU® L4 uses the global LoRaWAN network connection. There is no need for external power supply. ",
    lorawan: true,
    temperature: true,
    humidity: true,
    voc: true,
    co2: true,
    pm: true,
    image: IOTSU_L4_AQ08,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>40 x 125 x 125 mm<br> <b>Weight: </b>360g with battery<br> <b>Sensors: </b>Particulate Matter, CO₂, tVOC, Temperature, Humidity<br> <b>Transmission cycle: </b>2h, adjustable<br> <b>Measurement Cycle: </b>Transmission cycle / 4<br> <b>Connectivity: </b>LoRaWAN<br> <b>Battery: </b>D, 3.6v, lifetime with default settings 2.5 years, replaceable<br> <b>IP Class: </b>IP20<br> <b>Operating Conditions: </b>10°C to +40°C, Relative humidity 20-80% (Non-condensing) <br> <b>Typical Accuracy: </b>Temperature: ±0.2°C, CO2: ±(30ppm + 3% of reading), Humidity: ±2%, tVOC: ±15%, PM2.5: ± 10μg/m3, PM10: ± 25μg/m3 <br> <b>Certifications: </b>CE<br> <b>Mounting: </b>Adhesive tape<br>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L4_AQ08.pdf",
    }
    ]        
  },
  {
    id: 22,
    name: 'IOTSU L5R L04 GPS & Acceleration',
    description: "IOTSU® L5R L04 is a wireless device that measures GPS location data combined with acceleration. IOTSU® L5R L04 is designed for tracking cable reels. Tracking cable reels helps customers to improve inventory management and prevent disappearance of the reels.\n\n IOTSU® L5R L04 is easy and fast to mount on cable reels. The device is maintenance-free and encased in an industrial quality casing resistant to dust and splatter. Transmission and measurement cycles can be adjusted according to the need.\n\n IOTSU® L5R uses the global LoRaWAN network connection. There is no need for external power supply. ",
    lorawan: true,
    gps: true,
    accelleration: true,
    image: IOTSU_L5R_L04,
    moreInformation: {__html: '<h4>Technical specifications</h4> <b>Dimensions (LxWxH): </b>132.6 x 86.6 x 88mm<br/> <b>Weight: </b>388g with battery<br/> <b>Sensors: </b>GPS, Acceleration<br/> <b>Transmission Cycle: </b>Configurable, alerts<br/> <b>Connectivity: </b>LoRaWAN<br/> <b>IP Class: </b>67<br/> <b>Battery: </b>Size D, lifetime up to 10 years<br/> <b>Operating Temperature: </b>-30°C to +50°C<br/> <b>Mounting: </b>Screws<br/>'},
    documents: [{
      title: "Brochure",
      url: "/docs/IOTSU_L5R_L04.pdf",
    }
    ]        
  },
];


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      burgerVisible: false,
      // store the currently selected filters in state
      sigfoxEnabled: false,
      lorawanEnabled: false,
      temperatureEnabled: false,
      humidityEnabled: false,
      vocEnabled: false,
      gpsEnabled: false,
      atlasEnabled: false,
      co2Enabled: false,
      motionEnabled: false,
      accellerationEnabled: false,
      pressureEnabled: false,
      pmEnabled: false,
      epdEnabled: false,
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    
  }

  toggleBurger(event) {
    this.setState({burgerVisible :!this.state.burgerVisible})
    console.log(this.state.burgerVisible)
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.name === 'sigfoxEnabled' || 'lorawanEnabled' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });

  }

  componentDidMount() {
    console.log(this.state.height);
   
    window.addEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    this.setState({burgerVisible :false});
  }


  render() {
    // Create a filter
    const filter = {
      ...this.state.sigfoxEnabled && { "sigfox": true },
      ...this.state.lorawanEnabled && { "lorawan": true },
      ...this.state.temperatureEnabled && { "temperature": true },
      ...this.state.humidityEnabled && { "humidity": true },
      ...this.state.vocEnabled && { "voc": true },
      ...this.state.gpsEnabled && { "gps": true },
      ...this.state.atlasEnabled && { "atlas": true },
      ...this.state.co2Enabled && { "co2": true },
      ...this.state.motionEnabled && { "motion": true },
      ...this.state.accellerationEnabled && { "accelleration": true },
      ...this.state.pressureEnabled && { "pressure": true },
      ...this.state.epdEnabled && {"epd" : true},
      ...this.state.pmEnabled && {"pm": true}

    }

    // Do the filtering
    let results = devices.filter(item => {
      for (let key in filter) {
        if (item[key] === undefined || item[key] !== filter[key])
          return false;
      }
      return true;
    });

    // Sort by name
    results.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    // Push devices to view
    let devicesView = []


    if(this.state.burgerVisible) {
      devicesView.push (<div className="sidebar" style={{display: "block"}}>
            <form>
              <h4>Connectivity</h4>

              <input name="sigfoxEnabled" type="checkbox" checked={this.state.sigfoxEnabled} onChange={this.handleInputChange} /> Sigfox &nbsp;
            <input name="lorawanEnabled" type="checkbox" checked={this.state.lorawanEnabled} onChange={this.handleInputChange} /> LoRaWAN <br /><br />
              <h4>Features</h4>
              <input name="accellerationEnabled" type="checkbox" checked={this.state.accellerationEnabled} onChange={this.handleInputChange} /> Acceleration <br />
              <input name="co2Enabled" type="checkbox" checked={this.state.co2Enabled} onChange={this.handleInputChange} /> CO₂<br />
              <input name="pressureEnabled" type="checkbox" checked={this.state.pressureEnabled} onChange={this.handleInputChange} /> Differential Pressure <br />
              <input name="epdEnabled" type="checkbox" checked={this.state.epdEnabled} onChange={this.handleInputChange} /> e-Ink <br />
              <input name="humidityEnabled" type="checkbox" checked={this.state.humidityEnabled} onChange={this.handleInputChange} /> Humidity<br />
              <input name="motionEnabled" type="checkbox" checked={this.state.motionEnabled} onChange={this.handleInputChange} /> Motion <br />
              <input name="pmEnabled" type="checkbox" checked={this.state.pmEnabled} onChange={this.handleInputChange} /> Particulate Matter <br />
              <input name="temperatureEnabled" type="checkbox" checked={this.state.temperatureEnabled} onChange={this.handleInputChange} /> Temperature <br />
              <input name="vocEnabled" type="checkbox" checked={this.state.vocEnabled} onChange={this.handleInputChange} /> tVOC<br /><br />
              <h4>Location</h4>
              <input name="gpsEnabled" type="checkbox" checked={this.state.gpsEnabled} onChange={this.handleInputChange} /> GPS<br />
              <input name="atlasEnabled" type="checkbox" checked={this.state.atlasEnabled} onChange={this.handleInputChange} /> Sigfox Atlas<br />
            </form>

          </div>)
    }
    else {
      for (let i = 0; i < results.length; i++) {

        // add new lines with \n in the json
        devicesView.push(
         
          <div className="resultItem" key={i}>
            <div className="itemWrapper">
              <div className="itemImage">
                <img src={results[i].image} alt="" />
              </div>
              <div className="itemDesc">
                <b>{results[i].name}</b>
                <br />{results[i].description.split('\n').map((item, i) => {
                  return <p key={i}>{item}</p>;
                })}
                {results[i].sigfox ? <><img src={SIGFOX_LOGO}/><br/> </>: null }
                {results[i].lorawan ? <><img src={LORAWAN_LOGO}/> <br/></>: null }
                </div>
  
            </div>
           
            
            
            <Collapsible trigger="Show more information">
  
              <div dangerouslySetInnerHTML={results[i].moreInformation}></div>
              
              {results[i].moreInformation ? <br /> : null } {/* Don't render elements which don't exist in JSON */}
              {results[i].documents ? <h3>Downloads</h3> : null}
              {results[i].documents ? results[i].documents.map((document, i) => (
                <>
                  <img src={DOCUMENT_ICON} alt=""/><a href={document.url}>{document.title}</a><br />
                </>
  
              )) : null}
              <br/><h3>Purchase Options</h3>
              {results[i].purchase ? results[i].purchase.map((purchase, i) => (
                <>
                  <img src={purchase.icon} alt=""/>&nbsp;<a href={purchase.url}>{purchase.title}</a><br />
                </>
  
              ))
              : null }
              
              <img src={CONTACT_US} alt=""/>&nbsp;<a href="https://smalldatagarden.fi/contact/" rel="noreferrer">Contact Us</a><br/>
            </Collapsible>
  
          </div>
        )
  
      }
      if (devicesView.length === 0) {
        devicesView.push(<div className="noResults" key="0">Please broaden your search criteria.</div>)
      }
    }
    



    //document.body.style = 'background: #cdd5dc;';
    document.title = "IOTSU® Device Selector"

    return (

      <div className="mainContainer">

        <Navbar className="color-nav" variant="dark">
          <div onClick={(e)=>this.toggleBurger()}>
          <svg className="navBurger" viewBox="0 0 100 80" width="40" height="40">
    <rect width="100" height="20"></rect>
    <rect y="30" width="100" height="20"></rect>
    <rect y="60" width="100" height="20"></rect>
</svg>
          </div>
      
          <Navbar.Brand href="https://smalldatagarden.fi">
            <img
              alt=""
              src={BrandLogo}
              width="40"
              height="40"
              className="d-inline-block align-top"
            />{' '}
       &nbsp;&nbsp;&nbsp;IOTSU® Device Selector
     </Navbar.Brand>
        </Navbar>
        <div className="parent">
          <div className="sidebar">
            <form>
              <h4>Connectivity</h4>

              <input name="sigfoxEnabled" type="checkbox" checked={this.state.sigfoxEnabled} onChange={this.handleInputChange} /> Sigfox &nbsp;
            <input name="lorawanEnabled" type="checkbox" checked={this.state.lorawanEnabled} onChange={this.handleInputChange} /> LoRaWAN <br /><br />
              <h4>Features</h4>
              <input name="accellerationEnabled" type="checkbox" checked={this.state.accellerationEnabled} onChange={this.handleInputChange} /> Acceleration <br />
              <input name="co2Enabled" type="checkbox" checked={this.state.co2Enabled} onChange={this.handleInputChange} /> CO₂<br />
              <input name="pressureEnabled" type="checkbox" checked={this.state.pressureEnabled} onChange={this.handleInputChange} /> Differential Pressure <br />
              <input name="epdEnabled" type="checkbox" checked={this.state.epdEnabled} onChange={this.handleInputChange} /> e-Ink <br />
              <input name="humidityEnabled" type="checkbox" checked={this.state.humidityEnabled} onChange={this.handleInputChange} /> Humidity<br />
              <input name="motionEnabled" type="checkbox" checked={this.state.motionEnabled} onChange={this.handleInputChange} /> Motion <br />
              <input name="pmEnabled" type="checkbox" checked={this.state.pmEnabled} onChange={this.handleInputChange} /> Particulate Matter <br />
              <input name="temperatureEnabled" type="checkbox" checked={this.state.temperatureEnabled} onChange={this.handleInputChange} /> Temperature <br />
              <input name="vocEnabled" type="checkbox" checked={this.state.vocEnabled} onChange={this.handleInputChange} /> tVOC<br /><br />
              <h4>Location</h4>
              <input name="gpsEnabled" type="checkbox" checked={this.state.gpsEnabled} onChange={this.handleInputChange} /> GPS<br />
              <input name="atlasEnabled" type="checkbox" checked={this.state.atlasEnabled} onChange={this.handleInputChange} /> Sigfox Atlas<br />
            </form>

          </div>
          <div className="mainview" >
            {devicesView}

          </div>

        </div>

      </div>
    );

  }

}

export default App;